import React, { useEffect, useRef, useState } from "react";
import "./FilterStatusSelect.scss";
import DownArrowIcon from "../../../../../components/icons/DownArrowIcon";

const statusOptions = [
  { value: "hiring", label: "Hiring" },
  { value: "work_anniversary", label: "Work Anniversary" },
  { value: "birthday", label: "Birthday" },
  { value: "events", label: "Events" },
  {
    value: "transaction_success_showcase",
    label: "Transaction Success Showcase",
  },
  { value: "office_holiday", label: "Office Closure / Holiday" },
  { value: "awards", label: "Awards / Recognition" },
  { value: "promotions", label: "Promotions / Role Changes" },
  { value: "office_relocation", label: "Office Relocation / New Branch" },
];

const FilterAnnouncementType = ({ formik }: { formik: any }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const selectedLabel =
    statusOptions.find(
      (option) => option.value === formik?.values?.announcement_type
    )?.label || "Select Announcement Type";

  const handleSelect = (value: string) => {
    formik.setFieldValue("announcement_type", value);
    setDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="agent-announcement-contain-container" ref={containerRef}>
      <div className="agent-heading">
        <p>Announcement Type</p>
      </div>

      <div className="filter-search-listing">
        <input
          type="text"
          placeholder="Select Announcement Type"
          className="filter-search-input"
          value={selectedLabel}
          onClick={() => setDropdownOpen(!dropdownOpen)}
          readOnly
        />
        <div
          className={`filter-down-arrow-icon ${dropdownOpen ? "open-box" : ""}`}
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <DownArrowIcon />
        </div>
      </div>

      {dropdownOpen && (
        <div className="review-list-container">
          {statusOptions.map((option) => (
            <div
              key={option.value}
              className={`agent-list-item ${
                formik.values.review_type === option.value
                  ? "agent-list-item-active"
                  : ""
              }`}
              onClick={() => handleSelect(option.value)}
            >
              <p className="item-profile-name">{option.label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterAnnouncementType;
